/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { DocumentsRequestBuilderNavigationMetadata, DocumentsRequestBuilderRequestsMetadata, type DocumentsRequestBuilder } from './documents/index.js';
// @ts-ignore
import { FoldersRequestBuilderNavigationMetadata, FoldersRequestBuilderRequestsMetadata, type FoldersRequestBuilder } from './folders/index.js';
// @ts-ignore
import { StatsRequestBuilderNavigationMetadata, type StatsRequestBuilder } from './stats/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/companydocs
 */
export interface CompanydocsRequestBuilder extends BaseRequestBuilder<CompanydocsRequestBuilder> {
    /**
     * The documents property
     */
    get documents(): DocumentsRequestBuilder;
    /**
     * The folders property
     */
    get folders(): FoldersRequestBuilder;
    /**
     * The stats property
     */
    get stats(): StatsRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const CompanydocsRequestBuilderUriTemplate = "{+baseurl}/api/companydocs";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const CompanydocsRequestBuilderNavigationMetadata: Record<Exclude<keyof CompanydocsRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    documents: {
        requestsMetadata: DocumentsRequestBuilderRequestsMetadata,
        navigationMetadata: DocumentsRequestBuilderNavigationMetadata,
    },
    folders: {
        requestsMetadata: FoldersRequestBuilderRequestsMetadata,
        navigationMetadata: FoldersRequestBuilderNavigationMetadata,
    },
    stats: {
        navigationMetadata: StatsRequestBuilderNavigationMetadata,
    },
};
/* tslint:enable */
/* eslint-enable */
